module.exports = __webpack_public_path__ + "static/media/bmw-go-drive.35109c12.jpg";